{
    "back_to_login": "Retour",
    "email": "Email",
    "forgotten_Pwd": {
        "title": "Mot de passe oublié ?",
        "description_1": "Indiquez votre mail de connexion.",
        "description_2": "Vous allez recevoir un lien pour réinilialiser votre mot de passe à cette adresse.",
        "description_warning": "Le lien est valide pendant 72 heures.",
        "success": "Un mail a été envoyé à l'adresse suivante :"
    },
    "password": "Mot de passe",
    "send_reset_mail": "Envoyer",
    "totp": {
        "title": "Authentification à double facteur",
        "input_label": "Saisir un code à usage unique pour terminer la connexion",
        "submit": "Vérifier le code",
        "no_access_message": "Vous ne pouvez pas accéder à votre compte?"
    }
}